import DateTime from "components/DateTime";
import { useDateTime, YYYY_MM_DD_T_HH_mm_ss } from "shared";

import { ScheduleTimeProps } from "./types";

const ScheduleTime = ({ fromMinutes, durationMinutes }: ScheduleTimeProps) => {
    const { startOfTime } = useDateTime();

    const showScheduleTime = (minutes: number) =>
        startOfTime("day")
            .add(minutes, "minutes")
            .format(YYYY_MM_DD_T_HH_mm_ss);

    const scheduleTimeFrom = () => showScheduleTime(fromMinutes);

    const scheduleTimeTo = () =>
        showScheduleTime(fromMinutes + durationMinutes);

    return (
        <>
            <DateTime date={scheduleTimeFrom()} format="LT" /> -{" "}
            <DateTime date={scheduleTimeTo()} format="LT" />
        </>
    );
};

export default ScheduleTime;
